<template>
    <div v-if="isVisible" class="finish-tour-modal">
        <div class="modal-overlay"></div>
        <div class="modal-content">
            <div class="modal-header">
                <h2>{{ currentItem.title }}</h2>
                <button class="close-button" @click="closeModal">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>

            <div class="modal-body">
                <div class="video-container">
                    <div v-if="isLoading" class="loading-spinner-overlay">
                        <div class="spinner"></div>
                    </div>
                    <iframe
                        v-show="!isLoading"
                        :src="
                            currentItem.videoUrl
                                ? currentItem.videoUrl + '?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3'
                                : currentItem.docsUrl
                        "
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                        @load="isLoading = false"
                    >
                    </iframe>
                </div>

                <div class="action-buttons">
                    <div class="resource-group">
                        <button class="btn docs-btn" @click="gotoDocumentation">
                            <svg
                                class="btn-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                            </svg>
                            {{ $t("setupWizard.finishModalDoc") }}
                        </button>
                        <button class="btn support-btn" @click="openSupport">
                            <svg
                                class="btn-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                            </svg>
                            {{ $t("setupWizard.finsihModalLiveSupport") }}
                        </button>
                        <button class="btn videos-btn" @click="openVideos">
                            <svg
                                class="btn-icon"
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            >
                                <polygon points="23 7 16 12 23 17 23 7"></polygon>
                                <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                            </svg>
                            {{ $t("setupWizard.finishModalVideos") }}
                        </button>
                    </div>
                        <a-tooltip
                            placement="left"
                            :overlayStyle="{ zIndex: '99999 !important' }"
                            :title="$t('setupWizard.completedWarning')"
                        >
                            <button
                                class="btn close-btn"
                                @click="completeTutorial"
                            >
                                {{ $t("setupWizard.completed") }}
                            </button>
                        </a-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { finishModalItems } from "./finishModalItems";
import { completeTutorial } from "../../api/user";
import { getSetupItems } from "./setupItems";
import { mapActions, mapState } from "vuex";

export default {
    name: "FinishTourModal",
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        tourKey: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
        currentItem() {
            return (
                finishModalItems(this).find((item) => item.key === this.tourKey) || {
                    title: this.$t("setupWizard.moreInfo"),
                    description: "",
                    videoUrl: "https://www.youtube.com/embed/DEFAULT_VIDEO_ID",
                    docsUrl: "https://docs.supsis.com",
                }
            );
        },
    },
    methods: {
        ...mapActions({
            profile: "auth/profile",
        }),
        completeTutorial() {
            const { systemOptions, moduleSelections, moduleSelectionsTwo } = this.$_.get(this.site, "lobbyData", {});
            let setupItems = getSetupItems(
                this.user.guideTutorials,
                systemOptions,
                moduleSelections,
                moduleSelectionsTwo,
                this
            );
            setupItems = setupItems.map((item) => {
                if (item.key === this.tourKey) item.completed = true;
                return item;
            });
            const isCompletedAll = setupItems.every((item) => item.completed);
            completeTutorial(this.tourKey, isCompletedAll).then(() => {
                this.closeModal();
                this.profile();
            });
        },
        closeModal() {
            this.$emit("close");
        },
        gotoDocumentation() {
            window.open(this.currentItem.docsUrl, "_blank");
        },
        openSupport() {
            window.open("https://visitor.supsis.live", "_blank");
        },
        openVideos() {
            window.open("https://www.youtube.com/@supsis_ai", "_blank");
        },
    },
};
</script>

<style lang="scss" scoped>
.finish-tour-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
}

.modal-content {
    position: relative;
    background: white;
    border-radius: 16px;
    width: 90%;
    max-width: 900px;
    max-height: 90vh;
    z-index: 1;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 5px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h2 {
        margin: 0;
        color: #111827;
        font-size: 1.5rem;
        font-weight: 600;
    }

    .close-button {
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        color: #6b7280;
        border-radius: 50%;
        transition: all 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background: #f3f4f6;
            color: #111827;
        }
    }
}

.modal-body {
    padding: 0 24px 24px;
    overflow-y: auto;
    flex: 1;
}

.video-container {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    margin: 16px 0 24px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }
}

.loading-spinner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 10;
}

.spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #4f46e5;
    animation: spin 1s ease infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.description {
    margin: 0 0 16px;
    color: #4b5563;
    line-height: 1.6;
    font-size: 0.95rem;
}

.action-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-top: 24px;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 12px;
    }
}

.resource-group {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        width: 100%;
    }

    @media (max-width: 480px) {
        flex-direction: column;
    }
}

.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 20px;
    border-radius: 10px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    border: none;
    gap: 8px;
    white-space: nowrap;

    &-icon {
        flex-shrink: 0;
    }

    &.docs-btn {
        background-color: #e0f2fe;
        color: #0369a1;

        &:hover {
            background-color: #bae6fd;
            transform: translateY(-1px);
        }
    }

    &.support-btn {
        background-color: #f0fdf4;
        color: #15803d;

        &:hover {
            background-color: #dcfce7;
            transform: translateY(-1px);
        }
    }

    &.videos-btn {
        background-color: #fef2f2;
        color: #b91c1c;

        &:hover {
            background-color: #fee2e2;
            transform: translateY(-1px);
        }
    }

    &.close-btn {
        color: #111827;
        padding: 10px 24px;
        border: 2px solid #111827;
        font-weight: 600;
        margin-left: auto;

        &:hover {
            background-color: #f3f4f6;
            border-color: black;
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }

        @media (max-width: 768px) {
            width: 100%;
            margin-left: 0;
        }
    }
}
</style>
